import React from 'react';

import { ColorPalette } from 'theme/colors';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { InfoContainer, IconContainer, Content, Title, Value } from './styles';

export interface Props {
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  title: string;
  value?: string;
}

const ProfileInfo = ({ icon: Icon, title, value }: Props) => {
  const { t } = useStoreTranslation();
  const active = !!value;

  return (
    <InfoContainer>
      <IconContainer>
        {Icon && <Icon color={active ? ColorPalette.HEX.OriolesOrange : ColorPalette.HEX.Manatee} />}
      </IconContainer>
      <Content>
        <Title $active={active}>{title}</Title>
        <Value $active={active}>{value || t('profileInfo.noInfo')}</Value>
      </Content>
    </InfoContainer>
  );
};

export default ProfileInfo;
